import TextArea from 'antd/lib/input/TextArea';
import { AddNoteFooter } from 'leash/components/notes/Notes.styles';
import { Button } from 'antd';
import React, { ChangeEvent, useState } from 'react';
import { apiNote } from 'utilities/http/api/leash/apiNote';
import { notify } from 'utilities/notifications/notify';
import userStorage from 'utilities/user/userStorage';
import { log } from 'utilities/log/log';
import { NoteMessage, UseStateSetter } from 'types';

interface Props {
  setNotes: UseStateSetter<NoteMessage[]>;
  notes: NoteMessage[];
  setShowDrawer: UseStateSetter<boolean>;
  travelPackageId: number;
  readOnly?: boolean;
}

export function NotesFooter(props: Props) {
  const { setShowDrawer, travelPackageId, setNotes, notes, readOnly } = props;
  const [isPosting, setIsPosting] = useState(false);
  const [message, setMessage] = useState('');

  const postNote = async () => {
    setIsPosting(true);
    try {
      const postResponse = await apiNote.postNote(travelPackageId, message);
      if (!postResponse.isOk) {
        notify.error("Couldn't create the note, please try again");
        return;
      }

      notify.success('Note posted!');

      const createdNote: NoteMessage = {
        ...postResponse.json.note,
        author: {
          firstName: userStorage.getUser()?.firstName ?? '',
          lastName: userStorage.getUser()?.lastName ?? '',
        },
      };

      setNotes([...notes, createdNote]);
      setMessage('');
    } catch (e) {
      log.debug(e);
      notify.error('Error creating the note');
    }

    setIsPosting(false);
  };

  const onChangeNote = (e: ChangeEvent<HTMLTextAreaElement>) =>
    setMessage(e.target.value);

  const onCancel = () => {
    setShowDrawer(false);
    setMessage('');
  };

  return (
    <>
      <TextArea
        size="large"
        showCount
        maxLength={200}
        placeholder="Type your message here..."
        autoSize={{ minRows: 4, maxRows: 5 }}
        value={message}
        onChange={onChangeNote}
        data-testid="note-textarea"
        disabled={readOnly}
      />
      <AddNoteFooter>
        <Button type="ghost" onClick={onCancel} data-testid="cancel-note">
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={postNote}
          loading={isPosting}
          data-testid="post-note"
          disabled={!message || message.length <= 3}
        >
          Post
        </Button>
      </AddNoteFooter>
    </>
  );
}
